export default __webpack_public_path__ + "static/Aurora-083b55fc4f63a43ed9c1c685d41f8c63.png";